'use strict';

module.exports = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        clearTimeout(timeout);

        timeout = setTimeout(function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        }, wait);

        if (immediate && !timeout) {
            func.apply(context, args);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/utilities/debounce.js
// module id = 12
// module chunks = 0